module.exports = __webpack_public_path__ + "static/yuan_ti_abomination-e9e77fcd7bca7dd6504dfea74ffda407.jpeg";